import React from 'react';
import { Link } from 'react-router-dom';

export function Navigation({ isScrolled = false }) {
  return (
    <header className={`header ${isScrolled ? 'shadow-md' : ''}`}>
      <div className="container">
        <Link to="/" className="logo">
          <img src="/favicon.png" alt="Oracle Gaming" />
        </Link>
        <nav className="navbar active" style={{ position: 'static', maxWidth: 'unset', height: 'auto' }}>
          <ul className="navbar-list">
            <li><Link to="/" className="navbar-link">Home</Link></li>
            <li><Link to="/shop" className="navbar-link">Shop</Link></li>
            <li><Link to="/cart" className="navbar-link">Cart</Link></li>
            {/* Blog removed to match site header */}
          </ul>
        </nav>
      </div>
    </header>
  );
}



